import { getLog } from '@eigtech/ui-shared-logging'

export const log = getLog(import.meta.env.PROD ? 'silent' : 'trace')
